export const loadGtag = (GTAG_ID) => {
	if (window.gtag) return // Уникаємо повторного завантаження

	// Додаємо GTAG script
	const script = document.createElement("script")
	script.async = true
	script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`
	document.head.appendChild(script)

	// Ініціалізація GTAG
	window.dataLayer = window.dataLayer || []
	function gtag() { window.dataLayer.push(arguments) }
	window.gtag = gtag

	gtag("js", new Date())
	gtag("config", GTAG_ID)
}
